import styled from 'styled-components';
import { InviteWrapper, PageWrapper } from '../../../styles';

const PHONE_FRAME_HEIGHT = 760;
const PHONE_FRAME_BORDER = 1;
const PHONE_SCREEN_HEIGHT = PHONE_FRAME_HEIGHT - 2 * PHONE_FRAME_BORDER;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const PhoneFrame = styled.div`
  width: 390px;
  max-width: 100%;
  height: ${PHONE_FRAME_HEIGHT}px;
  overflow-y: auto;
  border: ${PHONE_FRAME_BORDER}px solid
    ${({ theme }) => theme.colors.semantic.border.default};
  border-radius: 24px;
`;

// Inerte no conteúdo, não no frame: o frame segue recebendo a rolagem
export const InertContent = styled.div`
  pointer-events: none;

  /* O convite usa 100vh, que aqui é a altura da janela, não a da tela do celular */
  ${PageWrapper}, ${InviteWrapper} {
    min-height: ${PHONE_SCREEN_HEIGHT}px;
  }
`;
